import React, { useContext } from 'react'
import { Typography } from 'antd'
import { CheckOutlined } from '@ant-design/icons'

import IntlMessages from '../../../util/IntlMessages'
import { ThemeContext } from '../../../context/themeContext'

import VTLogoPurple from '../../../assets/images/logo-purple.svg'
import VTLogoWhite from '../../../assets/images/logo.svg'

import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'
import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'

const { Paragraph } = Typography

const LeaveTrackingInfo = ({ selectedPlan }: { selectedPlan: SubscriptionPlanEnum }): React.ReactElement => {

  const { theme } = useContext(ThemeContext)
  return (
    <div className="content-leave-tracking-info">
      {
        theme === DARK_THEME ? <VTLogoWhite style={{ width: '240px' }} /> : <VTLogoPurple style={{ width: '240px' }} />
      }
      <h3>{
        selectedPlan === SubscriptionPlanEnum.freemium
          ? <IntlMessages id="createCompany.leaveTrackingInfo.freemium.title" />
          : <IntlMessages id="createCompany.leaveTrackingInfo.title" values={{ br: () => <br/> }} />
      }</h3>
      <Paragraph><CheckOutlined /> <IntlMessages id="createCompany.leaveTrackingInfo.item1" /></Paragraph>
      <Paragraph><CheckOutlined /> <IntlMessages id="createCompany.leaveTrackingInfo.item2" /></Paragraph>
      <Paragraph><CheckOutlined /> <IntlMessages id="createCompany.leaveTrackingInfo.item3" /></Paragraph>
      <Paragraph><CheckOutlined /> <IntlMessages id="createCompany.leaveTrackingInfo.item4" /></Paragraph>
      <Paragraph className="gdpr-soc">
        <img src="/signup/gdpr-icon.png" alt="GDPR" width={57} height={57} />
        <img src="/signup/soc2-icon.png" alt="SOC 2" width={57} height={57} />
      </Paragraph>
    </div>
  )
}

export default LeaveTrackingInfo
